import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { applyColorLuminance } from '../../libs/colors';
import * as sharedStyles from '../../libs/sharedStyles';
import FlatButton from './flat.jsx';

function getStyle(isActive, sentiment) {
	const sentimentColor = sharedStyles.vars.colors.assessments[sentiment];

	if (isActive) {
		return {
			color : '#FFF',
			backgroundColor : sentimentColor,
			':hover' : {
				backgroundColor : applyColorLuminance(sentimentColor, 0.2)
			}
		};
	} else {
		return {
			color : sharedStyles.vars.colors.ssGray,
			':hover' : {
				color : sentimentColor,
				borderColor : sentimentColor,
			}
		};
	}
}

const icons = {
	negative : 'exclamation-triangle',
	positive : 'check-square-o'
};

class AssessmentButton extends React.Component {
	render () {
		const style = _.assignIn({}, getStyle(this.props.isActive, this.props.sentiment), this.props.style);

		return (
			<FlatButton
				{...this.props}
				faIcon={icons[this.props.sentiment]}
				style={style}
			/>
		);
	}
}

AssessmentButton.propTypes = {
	isActive : PropTypes.bool,
	sentiment : PropTypes.oneOf(['neutral', 'positive', 'negative'])
};

AssessmentButton.defaultProps = {
	isActive : false,
	sentiment : 'neutral'
};

export default AssessmentButton;